export default "__VITE_ASSET__BahEI7pO__"